/**
 * Created by pandemio on 8/26/18.
 */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Class that handles the modal ters
 */
class ModalTerms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div>
                <span color="link" onClick={this.toggle} style={{textDecoration: "underline"}}> <Translate>{({translate}) => <span>{translate("terms.title")}</span>}</Translate></span>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className="modal-results">
                    <ModalHeader toggle={this.toggle}>
                        <Translate id="terms.title"/>
                    </ModalHeader>
                    <ModalBody>
                        <Translate>{({translate}) => <span>{translate("terms.conditions", null, { renderInnerHtml: true })}</span>}</Translate>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.toggle} color="info">
                            <Translate id="terms.close"/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
export default  ModalTerms;